import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({});
